import { Stack, Title } from '@mantine/core'
import { PageContainer } from '@shared/components/app-shell/page-container/page-container'
import { PAGE_TITLES } from '@/constants/page-titles'
import { useContext, useState } from 'react'
import { ColumnFiltersState, PaginationState } from '@tanstack/react-table'
import { StationContext } from '@/pages/station-context'
import { DEFAULT_PAGINATION_SIZE } from '@shared/components/table/table'
import { OffersTable } from '@/components/offers/offers-table/offers-table'
import { useAuthenticatedGraphQuery } from '@/hooks/use-authenticated-query'
import { ListOffersGql } from '@/graphql/queries/offers/list-offers.graphql'
import { ListOffersOrderByOptions } from '@shared/grower-api/.generated/types'
import { AlertLevel, IconAlert } from '@shared/components/icon-alert/icon-alert'

export function OffersListPage() {
  const { station } = useContext(StationContext)
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: DEFAULT_PAGINATION_SIZE,
  })
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])

  const { data, isError, isFetching, isLoading, error } = useAuthenticatedGraphQuery({
    queryKey: ['listOffers', station.recordNumber, pagination, columnFilters],
    gql: ListOffersGql,
    queryParams: {
      currentPage: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      orderBy: ListOffersOrderByOptions.Created,
      orderByAscending: false,
      stationRecordNumber: station.recordNumber,
      offerStatuses: columnFilters.find((filter) => filter.id === 'status')?.value as string,
    },
  })

  if (isError && error.response?.status === 403) {
    return (
      <Stack>
        <Title order={2}>Offers</Title>
        <IconAlert
          title='Restricted Access'
          level={AlertLevel.WARNING}
          message='You do not have permission to view offers for this station.'
        />
      </Stack>
    )
  }

  return (
    <PageContainer title={PAGE_TITLES.OFFERS}>
      <Stack>
        <Title order={2}>Offers</Title>
        <OffersTable
          data={data?.listOffers}
          stationRecordNumber={station.recordNumber}
          isError={isError}
          isFetching={isFetching}
          isLoading={isLoading}
          pagination={pagination}
          setPagination={setPagination}
          columnFilters={columnFilters}
          setColumnFilters={setColumnFilters}
        />
      </Stack>
    </PageContainer>
  )
}
